export default __webpack_public_path__ + "static/media/Vugarsresume.e0e43024.pdf";